"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterDonateAndSubscribe = void 0;

var _react = require("react");

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _jsxRuntime = require("react/jsx-runtime");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FooterDonateAndSubscribe = function FooterDonateAndSubscribe(_ref) {
  var listId = _ref.listId,
      tag = _ref.tag;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      displayMessage = _useState2[0],
      setDisplayMessage = _useState2[1];

  (0, _react.useEffect)(function () {
    if (displayMessage) {
      var id = setTimeout(function () {
        setDisplayMessage(false);
      }, 3000);
      return function () {
        return clearTimeout(id);
      };
    }
  }, [displayMessage]);

  var handleCopy = function handleCopy() {
    setDisplayMessage(true);
  };

  return (0, _jsxRuntime.jsxs)(_atoms.Flex, {
    flexDirection: "column",
    justifyContent: "space-evenly",
    width: {
      _: '100%',
      lg: '20%'
    },
    height: "100%",
    order: {
      _: 2,
      lg: 4
    },
    children: [(0, _jsxRuntime.jsxs)(_atoms.Flex, {
      flexDirection: "column",
      alignItems: {
        _: 'center',
        lg: 'flex-start'
      },
      children: [(0, _jsxRuntime.jsx)(_atoms.Body, {
        fontWeight: "500",
        color: "white",
        children: "Donate"
      }), (0, _jsxRuntime.jsxs)(_atoms.Flex, {
        flexDirection: {
          _: 'column',
          lg: 'row'
        },
        alignItems: {
          _: 'center',
          lg: 'flex-start'
        },
        children: [(0, _jsxRuntime.jsx)(_molecules.DonateButton, {
          icon: "ether",
          address: "0x4bbeEB066eD09B7AEd07bF39EEe0460DFa261520",
          onCopy: handleCopy,
          children: "Ethereum"
        }), (0, _jsxRuntime.jsx)(_molecules.DonateButton, {
          icon: "bitcoin",
          address: "32oirLEzZRhi33RCXDF9WHJjEb8RsrSss3",
          onCopy: handleCopy,
          children: "Bitcoin"
        })]
      }), (0, _jsxRuntime.jsx)(_atoms.Flex, {
        flexDirection: "row",
        alignItems: "baseline",
        minHeight: "20px",
        children: displayMessage && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_atoms.Body, {
            mr: "7px",
            color: "#7ad832",
            children: "\u2713"
          }), (0, _jsxRuntime.jsx)(_atoms.Body, {
            fontSize: "14px",
            color: "text.footer",
            children: "Address Copied to Clipboard!"
          })]
        })
      })]
    }), (0, _jsxRuntime.jsxs)(_atoms.Flex, {
      flexDirection: "column",
      width: "100%",
      alignItems: {
        _: 'center',
        lg: 'flex-start'
      },
      mt: {
        _: '30px',
        lg: 0
      },
      children: [(0, _jsxRuntime.jsx)(_atoms.Body, {
        color: "text.footer",
        mb: "5px",
        children: "Subscribe to MyCrypto"
      }), (0, _jsxRuntime.jsx)(_atoms.Body, {
        fontSize: "14px",
        lineHeight: "17px",
        fontWeight: "300",
        color: "text.footer",
        mb: "10px",
        children: "Get updates from MyCrypto straight to your inbox!"
      }), (0, _jsxRuntime.jsx)(_molecules.SubscribeInput, {
        listId: listId,
        tag: tag
      }), (0, _jsxRuntime.jsx)(_atoms.Flex, {
        flexDirection: "row",
        alignItems: "baseline",
        flexWrap: "wrap",
        children: (0, _jsxRuntime.jsxs)(_atoms.Body, {
          variant: "small",
          fontSize: "10px",
          fontStyle: "italic",
          fontWeight: "300",
          color: "footer.muted",
          mt: "10px",
          children: ["By submitting your email, you ", (0, _jsxRuntime.jsx)("strong", {
            children: "affirmatively"
          }), " agree to our", ' ', (0, _jsxRuntime.jsx)(_atoms.InlineBody, {
            as: "a",
            href: "https://mycrypto.com/privacy",
            variant: "link",
            fontSize: "10px",
            color: "link",
            sx: {
              textDecoration: 'none'
            },
            children: "Privacy Policy"
          })]
        })
      })]
    })]
  });
};

exports.FooterDonateAndSubscribe = FooterDonateAndSubscribe;